import {
    from,
    of,
    switchMap,
    throwError,
    finalize,
    retry,
    share,
    ReplaySubject,
    map,
    Subject,
    tap,
    startWith,
    EMPTY,
} from 'rxjs';

import { formatDateApi } from './date.js';
import { sessionToken, forgetSession, gotoLogin } from './session.js';

const ERROR_MESSAGES = {
    400: 'Ungültige Anfrage',
    401: 'Nicht authentifiziert',
    403: 'Zugriff verweigert',
    404: 'Ressource nicht gefunden',
    500: 'Interner Serverfehler, bitte später erneut versuchen',
    502: 'Schlechtes Gateway, bitte später erneut versuchen',
    503: 'Service temporal verfügbar, bitte später erneut versuchen',
};

export function formatApiErrorMessage(err) {
    if (err && err.status) {
        return ERROR_MESSAGES[err.status] || `Serverfehler ${err.status}`;
    }
    return 'Verbindungsfehler, bitte überprüfen Sie Ihre Internetverbindung';
}

let reloadDishesTrigger$ = new Subject();

export let dishes$ = reloadDishesTrigger$.pipe(
    startWith(undefined),
    switchMap(() => fetchJson('/dishes')),
    share({
        connector: () => new ReplaySubject(1),
        resetOnError: true,
        resetOnRefCountZero: true,
        resetOnComplete: true,
    })
);

export let dishesById$ = dishes$.pipe(
    map((dishes) => new Map(dishes.map((d) => [d.id, d]))),
    share({
        connector: () => new ReplaySubject(1),
        resetOnError: true,
        resetOnRefCountZero: true,
        resetOnComplete: true,
    })
);

export function createDish(dish) {
    return fetchJson('/dishes', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(dish),
    }).pipe(tap(() => reloadDishesTrigger$.next()));
}

let reloadPlanTrigger$ = new Subject();

export function getPlan(startDate) {
    return reloadPlanTrigger$.pipe(
        startWith(undefined),
        switchMap(() => fetchJson(`/plan/${formatDateApi(startDate)}`))
    );
}

export function planDish(day, dishId) {
    return fetchJson(`/plan/${formatDateApi(day)}/dishes`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            dish_id: dishId,
        }),
    }).pipe(tap(() => reloadPlanTrigger$.next()));
}

export function recommendDishes(day) {
    return fetchJson(`/plan/${formatDateApi(day)}/recommend`);
}

function fetchJson(url, opts = {}) {
    return of(undefined).pipe(
        switchMap(() => {
            let ctrl = new AbortController();
            let headers = {
                ...(opts.headers || {}),
                Authorization: `Bearer ${sessionToken}`,
            };
            let obs$ = from(
                fetch(`/api${url}`, {
                    ...opts,
                    headers,
                    signal: ctrl.signal,
                })
            );
            if ((opts.method || 'GET') === 'GET') {
                obs$ = obs$.pipe(
                    retry({
                        count: 3,
                        delay: 2000 + 1000 * Math.random(),
                    })
                );
            }
            return obs$.pipe(
                switchMap((resp) => {
                    if (resp.status === 403) {
                        forgetSession();
                        gotoLogin();
                        return EMPTY;
                    }
                    if (!resp.ok) {
                        return throwError(resp);
                    }
                    return from(resp.json());
                }),
                finalize(() => ctrl.abort())
            );
        })
    );
}
